import tagNav from './tagNav'
import common from './common'
export default {
    tagNav,
    common
}


// WEBPACK FOOTER //
// ./src/store/modules/index.js